import { render } from "./ResidentialPageFirstSectionCms.vue?vue&type=template&id=86a5148a"
import script from "../js/residential-page-first-section-cms.js?vue&type=script&lang=js"
export * from "../js/residential-page-first-section-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__